var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinePlotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4059 21.3562L49.3062 10.1138L52.732 12.8259L40.8773 27.8003L31.5775 19.0475L15.6421 38.8295L7.27379 29.9033L1.86259 34.9558L1.31641 35.502V29.4939L7.37506 23.6227L15.3923 32.1744L31.1355 12.6311L40.4059 21.3562Z",
    fill: "#3B82C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32031 0V50.7732H52.0935",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinePlotIcon);
export default __webpack_public_path__ + "static/media/line_plot_icon.f8e7ba16.svg";
export { ForwardRef as ReactComponent };